<app-breadcrumb
  Titulo="Informações do Cliente"
  Pagina="Info-Cliente"
></app-breadcrumb>

<div class="row">
  <div class="col-md-12">
    <div class="fundo-cinza-arrendondado fundo-vertical">
      <div class="row">
        <div class="fundo-iniciais">{{ buscarIniciais(clienteDetalhes.nome) }}</div>
        <div class="texto-nome">
          <h5>{{clienteDetalhes.nome}} <span class="star-icon"><i class="fa fa-star"></i></span></h5>
        </div>
        <div class="contatos" *ngIf="clienteDetalhes.responsavel != undefined">
          <div class="texto"> Responsável<br> {{clienteDetalhes.responsavel}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-3">
    <div class="fundo-cinza-arrendondado fundo-horizontal">
      <h6>Informações do cliente</h6>
      <div class="row">
        <div class="col-md-6 texto-info-cliente">
          {{clienteDetalhes.tipoDocumentoDescricao}}
        </div>
        <div class="col-md-6 texto-info-cliente text-right">
          {{formatarDocumento(clienteDetalhes.documento, clienteDetalhes.tipoDocumentoDescricao)}}
        </div>
        <div class="row" *ngFor="let contato of clienteDetalhes.contatos">
          <div class="col-md-6 texto-info-cliente" >
            Telefone
          </div>
          <div class="col-md-6 texto-info-cliente text-right">
            {{contato.descricao}}
          </div>
          <div class="col-md-6 texto-info-cliente" >
            Email
          </div>
          <div class="col-md-6 texto-info-cliente text-right">
            {{contato.email}}
          </div>
        </div>


      </div>
      <hr style="margin-top: 30px; margin-bottom: 30px;">
      <h6>Histórico de Movimentações</h6>
      <div class="row" style="margin-top: 20px;">
        <div class="col-md-12 texto-info-movimentacao" *ngFor="let movimentacao of clienteDetalhes.historico">
          {{movimentacao.texto}}<br>
          Data: {{movimentacao.dataCadastro | date:'dd/MM/yyyy hh:mm:ss'}}<br>
          Usuario: {{movimentacao.usuario}}
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-9">
    <div class="fundo-cinza-arrendondado fundo-horizontal margin-left">
      <app-atendimento-detalhes [atendimentos]="clienteDetalhes.atendimentos" (atualizarListaPai)="onAtualizarAtendimentos()"></app-atendimento-detalhes>
    </div>
  </div>
</div>
